<template>
    <div class="gallery-container" style="width: 45vw; min-width:350px;">
        <Modal :showDialog="showDialog == 'RESETPWD'" :title="$t('ResetPassword')"  @close="resetPwdClosed">
            <reset-password-modal :email="user.email" @close="resetPwdClosed"></reset-password-modal>
        </Modal>
        <div id="info-container">
            <div>
                <div class="horizontal" style="justify-content: space-between">
                    <p class="section-title">{{$t('USER_INFORMATION')}}</p>
                    <div @click="openPhotoSelect">
                        <img v-if="photo != null" :src="photo"  style="width: 34px; height: 34px; border-radius: 50%; margin-right: 10px;"/>
                        <input id="file-chooser" style="display: none;" type="file" name="file" accept="image/*" @change.prevent="photoChange"/>
                    </div>
                </div>
                <div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Name')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.firstName" type="text" :placeholder="$t('FirstName')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Surname')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.surname" type="text" :placeholder="$t('LastName')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Email')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.email" type="email" :placeholder="$t('Email')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Password')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <button :class="'Active_Button'" @click="resetPasswordModal()">{{$t('ChangePassword')}}</button>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('PhoneNumber')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.phoneNumber" type="text" :placeholder="$t('PhoneNumber')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Address')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.address" type="text" :placeholder="$t('Address')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('City')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.city" type="text" :placeholder="$t('City')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{$t('Country')}}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.country" type="text" :placeholder="$t('Country')">
                            </td>
                        </tr>
                    </div>
                    <!-- <div class="info-field vertical">
                        <div>
                            <p class="info-field-title">Notification</p>
                        </div>
                        <div id="notification_chooser">
                            <button :class="user.notification ? 'Inactive_Button' : 'Active_Button'" @click="user.notification = false">Inactive</button>
                            <button :class="user.notification ? 'Active_Button' : 'Inactive_Button'" @click="user.notification = true">Active</button>
                        </div>
                    </div> -->
                    <!-- <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">Notifications Interval (min)</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.notificationInterval" type="text" placeholder="Notifications Interval">
                            </td>
                        </tr>
                    </div> -->
                </div>
            </div>
            <div style="align-self: center;">
                <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>
    </div>
</template>

<script>
    import TextField from '@/components/TextField'
    import Button from '@/components/Button'
    import { getUserData, updateCurrentUserData, getUserPhoto, updateUserPhoto } from '@api'
import Modal from '../Modal.vue';
import ResetPasswordModal from './ResetPasswordModal.vue';

export default {

    props: [],
    watch: {

    },
    methods: {
        getData: async function(){
            var user = await getUserData();
            this.user = user;
            var response = await getUserPhoto(user.id);
            this.photoData = response.data
            if(this.photoData != null) {
                this.photo = URL.createObjectURL(this.photoData);
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        async save() {
            await updateCurrentUserData(this.user);
            var user = await getUserData()
            var formData = new FormData();
            formData.append('Image', this.photoData)
            formData.append('ImageType', this.photoData.type)
            await updateUserPhoto(user.id, formData)
            var fullName = `${user.firstName} ${user.surname}`
            this.$store.dispatch('update_profile', fullName)
            this.$store.dispatch('update_avatar', this.photoData)
            this.$emit('save');
        },
        photoChange(e) {
            this.photo = URL.createObjectURL(e.target.files[0]);
            this.photoData = e.target.files[0];
        },
        openPhotoSelect() {
            document.getElementById('file-chooser').click()
        },
        closeDialog() {
            this.$emit('cancel');
        },
        resetPasswordModal(){
            this.showDialog = 'RESETPWD'
        },
        resetPwdClosed() {
            this.showDialog = 'NONE'
        }
    },
    computed: {
    },
    components: {
        Button,
        TextField,
        Modal,
        ResetPasswordModal
    },
    mounted: function () {
        this.getData();
    },
    data: function() {
        return {
            user: {},
            photo: null,
            photoData: null,
            showDialog: 'NONE'
        }
    }
}

</script>

<style scoped>

#info-container {
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

input[type=text], input[type="email"], input[type="password"] {
    border: none;
    width: 100%;
}

input[type=text]:focus, input[type="email"]:focus, input[type="password"]:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}

select {
    border: none;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}

#notification_chooser {
  background: #ffffff;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
}

#notification_chooser .Inactive_Button {
  align-self: center;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  height: 36px;
  width: 100%;
  margin: 3px;
  transition: 0.8s;
  color: black;
  font-weight: bolder;
  font-size: 1.8vh;
  border: none;
}

#notification_chooser .Active_Button {
  align-self: center;
  cursor: pointer;
  height: 36px;
  width: 100%;
  transition: 0.8s;
  margin: 3px;
  background: #347C93;
  color: white;
  border-radius: 4px;
  font-weight: bold;
  font-size: 1.8vh;
  border: none;
}

#notification_chooser .Inactive_Button:hover {
  background: #347C93aa;
  color: white;
  transition-delay: 0.3ms;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/EditProfile.vue